module.exports = __webpack_public_path__ + "img/box.c2c6f674.svg";